export default __webpack_public_path__ + "static/O0068-f2fd5368ded48f503fa497f63fc36279.png";